import React from 'react';

// Components //
import TitleSection from "../../molecules/title-section";
import Button from "../../atoms/button/button";

// Utils //
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';

// Interface //
import { ReferenciaContenido } from '../../../interfaces/ReferenciaContenido';

// Styles //
import "./MentorshipRecommendations.scss";
import { withPrefix } from 'gatsby';

const MentorshipRecommendations = (props: ReferenciaContenido) => {
    return (
        <div className="o-mentorship-recommendations">
            <div className="container">
                <div className="o-mentorship-recommendations__inner">
                    <div className="o-mentorship-recommendations__inner__text">
                        <TitleSection title={props.tituloGeneral} />
                        {contentfulRenderOptions(props.descripcion.json)}
                        {props.tituloBoton && (
                            <Button
                                type="link"
                                text={props.tituloBoton}
                                classname={`a-button__magenta gtm_conocer_requisitos_home_subsidio_desempleo_componente_requisitos`}
                                isDisabled={false}
                                href={withPrefix(props.redireccionBoton)}
                            />
                        )}
                    </div>
                    <div className="o-mentorship-recommendations__inner__image">
                        <img src={props.imagenPrincipal.file.url} alt={props.imagenPrincipal.file.fileName} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MentorshipRecommendations;